import { Grid, WithStyles, withStyles } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import DialogLarge from "../common/DialogLarge";
import MyPATTabs from "../../common/MyPATTabs";
import MyPATTab from "../../common/MyPATTab";
import YourTaskListing from "../components/YourTaskListing";
import { getOwnerTaskByRoleData } from "../actions/contentRequestActions";
import _ from 'lodash';
import contentRequestServices from "../services/contentRequestServices";
import { ContentRequest, Question, Subject } from "../types/ContentRequest";
import MyPATStep, { MyPATStepTitle, MyPATStepSubHeading } from "../../common/MyPATStep";
import MyPATStepper from "../../common/MyPATStepper";
import { StepStatus } from "../../common/types/Stepper";
import { dateService } from "../../common";
import OrderNotes from "../components/OrderNotes";
import { convertRequestPriorityToDislayValue, getRequestCreatorName } from "../helpers/createContentRequest";
import ProgressBar from "./CardData/CardDataTabs/ProgressBar";
import { RouteComponentProps } from "react-router";
import MyPATTruncateText from "../../common/MyPATTruncateText";
import { TrackRequestProcess } from "./CardData/CardDataTabs";
import { bindActionCreators } from 'redux';
import { contentRequestStateAction } from '../reducers/contentRequestStates';
import contentRequestService from '../services/contentRequestServices';
import { contentRequestAccordianActions } from '../reducers/contentRequestAccordianState';
import RequestHistoryDrawer from "../components/RequestHistoryDrawer";
import classNames from "classnames";
interface ContentReceivedRequestLandingProps
  extends WithStyles<typeof userStyles>, RouteComponentProps {
  match: any;
  getOwnerTaskByRoleData: Function;
  ownerTaskByRoleData: any;
  contentRequest: ContentRequest;
  setContentRequestState: Function,
  progressBarForQuestion: any,
  progressBarForTest: any,
  setIsTabOpened:Function,
}
interface ContentReceivedRequestLandingState {
  isJobDoneDisabled: boolean,
  statusCreated: string, 
  statusEvaluted: string, 
  statusLang: string, 
  statusModerated: string, 
  statusPublished: string,
  progressCountCreator: number,
  progressCountEvaluator: number,
  progressCountLangEval: number,
  progressCountModerator: number,
  progressCountPublisher: number,
  hideProgressModerator: boolean,
  hideProgressEval: boolean,
  hideProgressLang: boolean,
  totalCount: any,
  createdBy: string,
  evaluatedBy: string,
  langEvaluatedBy: string,
  moderatedBy: string,
  publishedBy: string,
  activeType: string;
  showContentHistory: boolean;
}

const marginLeft = '900px';
const notYetStarted = 'Not Yet Started';
const inProgress = 'In Progress';
// const createdBy = 'By You . 3:20 PM, 2nd Nov';

class ContentReceivedRequestLandingContainer extends Component<
  ContentReceivedRequestLandingProps,
  ContentReceivedRequestLandingState
> {
  constructor(props: ContentReceivedRequestLandingProps) {
    super(props);
    this.state = {
      isJobDoneDisabled: false,
      statusCreated: StepStatus.PENDING,
      statusEvaluted: StepStatus.PENDING,
      statusLang: StepStatus.PENDING,
      statusModerated: StepStatus.PENDING,
      statusPublished: StepStatus.PENDING,
      progressCountCreator: 0,
      progressCountEvaluator: 0,
      progressCountLangEval: 0,
      progressCountModerator: 0,
      progressCountPublisher: 0,
      hideProgressModerator: false,
      hideProgressEval: false,
      hideProgressLang: false,
      totalCount: 0,
      createdBy:'',
      evaluatedBy:'',
      langEvaluatedBy:'',
      moderatedBy:'',
      publishedBy:'',
      activeType:'Question',
      showContentHistory: false
    };
    this.onJobDone = this.onJobDone.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.updateData = this.updateData.bind(this);
  }

  


  getRequestOwnerNames(owners: any){
    let requestOwnerNames='';
    if(owners.length === 0) {
      return '';
    }
   if(owners.length > 0) {
      for(let i=0; i<owners.length; i++){
        if(owners[i].client) {
          requestOwnerNames += owners[i].client.name + ','
        }
      }
   }
    return requestOwnerNames.slice(0, -1);
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const { setContentRequestState,setIsTabOpened } = this.props;
    const requestId = params.requestId;
    const authorType = params.authorType;
    this.props.getOwnerTaskByRoleData(requestId, authorType);   
    
    //setTimeout(()=>{
    contentRequestService.getOwnerTaskByRole(requestId, authorType).then((result: any) => {
      setContentRequestState({ ...result });
    });
    setIsTabOpened({
      booleanValue:false
    });
   // },1000);
  }

  componentDidUpdate(nextProps: ContentReceivedRequestLandingProps){
    if(nextProps.ownerTaskByRoleData !== this.props.ownerTaskByRoleData &&
      nextProps.contentRequest !== this.props.contentRequest){
      const { ownerTaskByRoleData } = this.props;
      let questionsData = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.subjects', '');
      let contentType = !_.isEmpty(ownerTaskByRoleData) && this.getContentType(ownerTaskByRoleData);
      let testData = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.testDetails', '');
      let testCount = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'totalCount', '');
      let all = 0;

      if(contentType === 'question'){
                questionsData && questionsData.forEach((indexData: any) => {
                const { contentRequestItemsId } = indexData;
                const { count = 0 } = indexData;

                indexData.questions.forEach((question: any) => {
                  all += question.count;
                })
              
            })
        }

  
        if(contentType === 'test'){
          all = testCount;
        }
        this.setState({
          totalCount: all
        })


        if( testCount === 0 && all ) {
          // countZero( {statusCreated: StepStatus.DONE} );
          this.setState({statusCreated: StepStatus.PENDING});
          this.setState({statusEvaluted: StepStatus.PENDING});
          this.setState({statusLang: StepStatus.PENDING});
          this.setState({statusModerated: StepStatus.PENDING});
          this.setState({statusPublished: StepStatus.PENDING});
        } else {
          
          if(contentType === 'question'){
            let totalCount = all;
            let tempCreate = 0, tempModerate = 0, tempLang = 0, tempEval = 0, tempPublish = 0;
            questionsData.forEach((indexData1: any) => {

                indexData1.questions.forEach((indexData:any) => {

                const { contentRequestItemsId } = indexData;
                if (contentRequestItemsId) {
                    const { contentRequestItemsId: { contentRequestId = '', contents = [], overallStatus = {} }, count = 0 } = indexData;
                    for( let i=0; i<contents.length; i++) {
                        if( contents[i].status.creator.isJobCompleted) {
                            this.setState(prevstate => ({ progressCountCreator: prevstate.progressCountCreator + 1}));
                            tempCreate += 1;
                        }
                        if( contents[i].status.publisher.isJobCompleted) {
                            this.setState(prevstate => ({ progressCountPublisher: prevstate.progressCountPublisher + 1}));
                            tempPublish++;
                        }
                    }
                    
                    if( contents.length === 0 ) {
                        this.setState({statusCreated: StepStatus.PENDING});
                    }
                    else {
                        (tempCreate === totalCount)? this.setState({statusCreated: StepStatus.DONE}) :
                        this.setState({statusCreated: StepStatus.INPROGRESS}); 
                    }
            
                    if( overallStatus.evaluator.isRequired === false) {
                        this.setState({statusEvaluted: StepStatus.PENDING});
                        this.setState({hideProgressEval: true});
                    }
                    else {
                        for( let i=0; i<contents.length; i++) {
                            if( contents[i].status.evaluator.isJobCompleted) {
                                this.setState(prevstate => ({ progressCountEvaluator: prevstate.progressCountEvaluator + 1}));
                                tempEval++;
                            }}
                        if( contents.length === 0 ) {
                            this.setState({statusEvaluted: StepStatus.PENDING});
                        }
                        else {
                            (tempEval === totalCount)? this.setState({statusEvaluted: StepStatus.DONE}) :
                            this.setState({statusEvaluted: StepStatus.INPROGRESS}); 
                        }
                    }
            
            
                    if( overallStatus.languageEvaluator.isRequired === false) {
                        this.setState({statusLang: StepStatus.PENDING});
                        this.setState({hideProgressLang: true});
                    }
                    else {
                        for( let i=0; i<contents.length; i++) {
                            if( contents[i].status.languageEvaluator.isJobCompleted) {
                                this.setState(prevstate => ({ progressCountLangEval: prevstate.progressCountLangEval + 1}));
                                tempLang++;
                        }}
                        if( contents.length === 0 ) {
                            this.setState({statusLang: StepStatus.PENDING});
                        }
                        else {
                            (tempLang === totalCount)? this.setState({statusLang: StepStatus.DONE}) :
                            this.setState({statusLang: StepStatus.INPROGRESS}); 
                        }
                    }
            
            
                    if( overallStatus.moderator.isRequired === false) {
                        this.setState({statusModerated: StepStatus.PENDING});
                        this.setState({hideProgressModerator: true});
                    }
                    else {
                        for( let i=0; i<contents.length; i++) {
                            if( contents[i].status.moderator.isJobCompleted) {
                                this.setState(prevstate => ({ progressCountModerator: prevstate.progressCountModerator + 1}));
                                tempModerate++;
                                }
                        }
                        if( contents.length === 0 ) {
                            this.setState({statusModerated: StepStatus.PENDING});
                        }
                        else {
                            (tempModerate === totalCount)? this.setState({statusModerated: StepStatus.DONE}) :
                            this.setState({statusModerated: StepStatus.INPROGRESS}); 
                        }
                    }
                    if( contents.length === 0 ) {
                        this.setState({statusPublished: StepStatus.PENDING});
                    }
                    else {
                        (tempPublish === totalCount)? this.setState({statusPublished: StepStatus.DONE}) :
                        this.setState({statusPublished: StepStatus.INPROGRESS}); 
                    }
            
            
                }
             })
          })
        }

          if(contentType === 'test' && testData && testData.contentRequestItemsId){
             // const { contentRequestItemsId: { contents = [], overallStatus = {} } = {} } = testData;
             const contents = _.get(testData, 'contentRequestItemsId.contents', [])
             const overallStatus = _.get(testData, 'contentRequestItemsId.overallStatus', [])
                   
            let totalCount = all;
            let tempCreate = 0, tempModerate = 0, tempLang = 0, tempEval = 0, tempPublish = 0;

            for (let i = 0; i < contents.length; i++) {
                if (contents[i].status.creator.isJobCompleted) {
                    this.setState(prevstate => ({ progressCountCreator: prevstate.progressCountCreator + 1 }));
                    tempCreate++;
                }
                if (contents[i].status.publisher.isJobCompleted) {
                    this.setState(prevstate => ({ progressCountPublisher: prevstate.progressCountPublisher + 1 }));
                    tempPublish++;
                }
            }

            // setActiveCreated;
            if (contents.length === 0) {
                this.setState({ statusCreated: StepStatus.PENDING });
            }
            else {
                (tempCreate === totalCount) ? this.setState({ statusCreated: StepStatus.DONE }) :
                    this.setState({ statusCreated: StepStatus.INPROGRESS });
            }

            if (overallStatus.evaluator && overallStatus.evaluator.isRequired === false) {
                this.setState({ statusEvaluted: StepStatus.PENDING });
                this.setState({ hideProgressEval: true });
            }
            else {
                for (let i = 0; i < contents.length; i++) {
                    if (contents[i].status.evaluator.isJobCompleted) {
                        this.setState(prevstate => ({ progressCountEvaluator: prevstate.progressCountEvaluator + 1 }));
                        tempEval++;
                    }
                }
                if (contents.length === 0) {
                    this.setState({ statusEvaluted: StepStatus.PENDING });
                }
                else {
                    (tempEval === totalCount) ? this.setState({ statusEvaluted: StepStatus.DONE }) :
                        this.setState({ statusEvaluted: StepStatus.INPROGRESS });
                }
            }


            if (overallStatus.languageEvaluator && overallStatus.languageEvaluator.isRequired === false) {
                this.setState({ statusLang: StepStatus.PENDING });
                this.setState({ hideProgressLang: true });
            }
            else {
                for (let i = 0; i < contents.length; i++) {
                    if (contents[i].status.languageEvaluator.isJobCompleted) {
                        this.setState(prevstate => ({ progressCountLangEval: prevstate.progressCountLangEval + 1 }));
                        tempLang++;
                    }
                }
                if (contents.length === 0) {
                    this.setState({ statusLang: StepStatus.PENDING });
                }
                else {
                    (tempLang === totalCount) ? this.setState({ statusLang: StepStatus.DONE }) :
                        this.setState({ statusLang: StepStatus.INPROGRESS });
                }
            }


            if (overallStatus.moderator && overallStatus.moderator.isRequired === false) {
                this.setState({ statusModerated: StepStatus.PENDING });
                this.setState({ hideProgressModerator: true });
            }
            else {
                for (let i = 0; i < contents.length; i++) {
                    if (contents[i].status.moderator.isJobCompleted) {
                        this.setState(prevstate => ({ progressCountModerator: prevstate.progressCountModerator + 1 }));
                        tempModerate++;
                    }
                }
                if (contents.length === 0) {
                    this.setState({ statusModerated: StepStatus.PENDING });
                }
                else {
                    (tempModerate === totalCount) ? this.setState({ statusModerated: StepStatus.DONE }) :
                        this.setState({ statusModerated: StepStatus.INPROGRESS });
                }
            }
            if (contents.length === 0) {
                this.setState({ statusPublished: StepStatus.PENDING });
            }
            else {
                (tempPublish === totalCount) ? this.setState({ statusPublished: StepStatus.DONE }) :
                    this.setState({ statusPublished: StepStatus.INPROGRESS });
            }


          }

        }

    }
  }

  onJobDone = (contentRequestId: string, role: string, contentType: string ) => {
    let that = this;
    if(this.state.activeType){
      contentType = this.state.activeType === 'Question' ? 'question' : 'test'
    }
    return async function  () {
      await  contentRequestServices.resolveReviewRequest({
           "contentRequestId": contentRequestId,
           "role": role,
           "contentType": contentType
         });
         that.props.getOwnerTaskByRoleData(contentRequestId, role);
        }    

  };

  setActiveTab(value: any) {
      this.setState({
        activeType: value
      })
  }
  updateData() {
    const {
      match: { params },
    } = this.props;
    const requestId = params.requestId;
    const authorType = params.authorType;
    this.props.getOwnerTaskByRoleData(requestId, authorType); 
}
  getGoalsForContent(data: any) {
    if(data && data.requestInfo && data.requestInfo.details && data.requestInfo.details.courseTypes.length >= 0) {
      return _.reduce(_.get(data, 'requestInfo.details.courseTypes', []), (acc: string[], s, index) => {
            let goalName = _.get(s, 'name')
            if (goalName) {
              acc.push(goalName);
            }
        return acc;
      }, []);
    }
   return []
  }
  getSubjectsForContent(data: any) {
    if(data && data.requestInfo && data.requestInfo.details && data.requestInfo.details.subjects.length >= 0) {
      return _.reduce(_.get(data, 'requestInfo.details.subjects', []), (acc: string[], s, index) => {
            let subName = _.get(s, 'name')
            if (subName) {
              acc.push(subName);
            }
        return acc;
      }, []);
    }
    return []
  }
  getContentTypeForTable(data: any) {
    if(this.getContentType(data) === 'test')
    {
      return 'both'
    }else {
      return 'questions'
    }
  }

  getContentType(data: any){
    if (_.get(data.requestInfo, 'type', '') === 'test' && !_.isEmpty(data.requestInfo.details.testDetails)){
      return 'test'
    } else {
      return 'question'
    }
  }

  percentageConvert = (totalCount: number, count: number) => {
    return Math.round(count*100/totalCount)
}

checkJobDoneDisabledForReview() {
  let isJobDoneDisabled = false;
  let isJobDoneDisableAfterReview = true;
  const {
    match: { params },
  } = this.props;
  const { ownerTaskByRoleData } = this.props;
  if(!_.isEmpty(ownerTaskByRoleData)){
    if(ownerTaskByRoleData && ownerTaskByRoleData.requestInfo && ownerTaskByRoleData.requestInfo.type === 'question') {
    ownerTaskByRoleData && ownerTaskByRoleData.requestInfo && ownerTaskByRoleData.requestInfo.details && ownerTaskByRoleData.requestInfo.details.subjects && ownerTaskByRoleData.requestInfo.details.subjects.forEach((subject: any) => {
      subject.questions.forEach((question: any) => {
        if(question.contentRequestItemsId === null) {
          isJobDoneDisabled = true;
        }
        if(question.contentRequestItemsId && question.contentRequestItemsId.overallStatus[params.authorType].isJobCompleted) {
          isJobDoneDisableAfterReview =  isJobDoneDisableAfterReview && true
        } else {
          isJobDoneDisableAfterReview =  false
        }
        if(question.contentRequestItemsId && question.contentRequestItemsId.contents.length === 0) {
          isJobDoneDisabled = true;
        }
        question && question.contentRequestItemsId && 
        question.contentRequestItemsId.contents &&
        question.contentRequestItemsId.contents.forEach((content: any) => {
          if(!content.status[params.authorType].isJobCompleted) {
            isJobDoneDisabled = true;
          }
        });
      });
    });

  } else {
    if(this.state.activeType === 'Question') {
      ownerTaskByRoleData && ownerTaskByRoleData.requestInfo && ownerTaskByRoleData.requestInfo.details && ownerTaskByRoleData.requestInfo.details.subjects && ownerTaskByRoleData.requestInfo.details.subjects.forEach((subject: any) => {
        subject.questions.forEach((question: any) => {
          if(question.contentRequestItemsId === null) {
            isJobDoneDisabled = true;
          }
          if(question.contentRequestItemsId && question.contentRequestItemsId.contents.length === 0) {
            isJobDoneDisabled = true;
          }
          if(question.contentRequestItemsId && question.contentRequestItemsId.overallStatus[params.authorType].isJobCompleted) {
            isJobDoneDisableAfterReview =  isJobDoneDisableAfterReview && true
          } else {
            isJobDoneDisableAfterReview =  false
          }
          question && question.contentRequestItemsId && 
          question.contentRequestItemsId.contents &&
          question.contentRequestItemsId.contents.forEach((content: any) => {
            if(!content.status[params.authorType].isJobCompleted) {
              isJobDoneDisabled = true;
            }
          });
        });
      });
    } else {
     // if test data is assigned
    if(ownerTaskByRoleData && 
      ownerTaskByRoleData.requestInfo && 
      ownerTaskByRoleData.requestInfo.details && 
      ownerTaskByRoleData.requestInfo.details.testDetails && 
      ownerTaskByRoleData.requestInfo.details.testDetails.contentRequestItemsId &&
      ownerTaskByRoleData.requestInfo.details.testDetails.contentRequestItemsId.overallStatus[params.authorType].isJobCompleted) {
      isJobDoneDisableAfterReview =  isJobDoneDisableAfterReview && true
    } else {
      isJobDoneDisableAfterReview =  false
    }
      ownerTaskByRoleData && 
      ownerTaskByRoleData.requestInfo && 
      ownerTaskByRoleData.requestInfo.details && 
      ownerTaskByRoleData.requestInfo.details.testDetails && 
      ownerTaskByRoleData.requestInfo.details.testDetails.contentRequestItemsId &&
      ownerTaskByRoleData.requestInfo.details.testDetails.contentRequestItemsId.contents.forEach((content: any) => {
        if(!content.status[params.authorType].isJobCompleted) {
          isJobDoneDisabled = true;
        }
      })
    }

  }
}
return (isJobDoneDisabled || isJobDoneDisableAfterReview);
}



  getMostRecentUpdatedAt = (dateValues:string[]) => {
    const updatedDateValues = dateValues.map((dateValue) => new Date(dateValue));
    let mostRecent = updatedDateValues[0];
   updatedDateValues.forEach((dateValue) => {
      if(dateValue > mostRecent){
        mostRecent = dateValue
      }
    })
    return mostRecent;
  }

  checkQuestionsData = (data:Subject[], roleToCheck: string) => {
    const updatedAtValues:string[] = []
   data && data.forEach((subject:Subject) => {
      subject.questions.forEach((question: Question) => {
        const updatedAt = _.get(question, `contentRequestItemsId.overallStatus.${roleToCheck}.updatedAt`, '')
         if(updatedAt) {
          updatedAtValues.push(updatedAt);
        }
      })
    })
   
    const mostRecentUpdatedAt = this.getMostRecentUpdatedAt(updatedAtValues);
    return mostRecentUpdatedAt;
  }

  checkTestData = (data: any, roleToCheck: string) => {

    const updatedAtValues:string[] = []
   const updatedAt = _.get(data, `contentRequestItemsId.overallStatus.${roleToCheck}.updatedAt`, '')
       
        if(updatedAt) {
          updatedAtValues.push(updatedAt);
        }
    
    const mostRecentUpdatedAt = this.getMostRecentUpdatedAt(updatedAtValues);
    return mostRecentUpdatedAt;
}

  getUpdatedAtTime = (roleToCheck: string) => {
    const { ownerTaskByRoleData } = this.props;
    let updatedAt = '';
    let subjectsData = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.subjects', []);
    let testData = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.testDetails', {});
    let contentType = !_.isEmpty(ownerTaskByRoleData) && this.getContentType(ownerTaskByRoleData);
    return  contentType === 'question' ? this.checkQuestionsData(subjectsData, roleToCheck) :this.checkTestData(testData, roleToCheck);
  }



  checkLoggedInUserRole = () => {
    return this.props.match.params.authorType
  }

  setAuthoredBy = (role: string) => {
    return <>By you <span>&bull;</span> {dateService.timeDate(this.getUpdatedAtTime(role))}</>;
  }

  getEndDateByRole = (data: any) => {
    const authorType = this.props.match.params.authorType;
    let endDate;
    const owners = _.get(data, 'requestInfo.owners', []);
    owners.forEach((owner:any) => {
      endDate = owner.roles[authorType].endDate
    })
    return endDate;
  }
  getFooterCTA(authorType: string) {
    const { ownerTaskByRoleData } = this.props;
    let contentType = !_.isEmpty(ownerTaskByRoleData) && this.getContentType(ownerTaskByRoleData);
    let data ;
    if(contentType === 'question') {
      data = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.subjects[0].questions[0].contentRequestItemsId.overallStatus', '');
    } else {
      if(this.state.activeType === 'Question') {
        data = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.subjects[0].questions[0].contentRequestItemsId.overallStatus', '');
      } else {
        data = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.testDetails.contentRequestItemsId.overallStatus', '');
      }
    }
        if(!_.isEmpty(ownerTaskByRoleData) && data!== ''){
        if(authorType === "evaluator") 
        {
         if(data && data.languageEvaluator.isRequired) {
          return 'Submit for Language Evaluation'
         } else if(data && data.moderator.isRequired) {
          return 'Submit for Moderation'    
        } else {
          return 'Submit for Publishing'
        }
        } else
        if(authorType === "languageEvaluator") {
        if(data && data.moderator.isRequired) {
          return 'Submit for Moderation'    
        }else {
          return 'Submit for Publishing'
        }
        } else if (authorType === 'moderator')
        {
          return 'Submit for Publishing'
        } else {
          return 'Publish Content'
        }
      } else {
        if(authorType === "evaluator") 
        {
          return 'Submit for Language Evaluation'
        } else if(authorType === "languageEvaluator") {
          return 'Submit for Moderation'    
        } else if(authorType === "moderator"){
          return 'Submit for Publishing'
        } else {
          return 'Publish Content'
        }
      }
  }

  getAllQuestionsData = (data: any) => {
    if(data){
      const allQuestions:any = []
      const subjects = _.get(data, 'requestInfo.details.subjects', []);
      subjects.forEach((subject: any) => {
        subject.questions.forEach((question: any) => {
          allQuestions.push(question);
        })
      })
    return allQuestions;
    }
  }

  getIsJobDoneIsRequired = (type: string, filterArray: any, testDetails: any, authorType: string) => {
    let isJobDoneIsRequired = false;
    let overAllStatusOfRole = 0;
    if ((type === 'test' && filterArray.length) || type === 'question' || type === 'Question') {
      filterArray && filterArray.length && filterArray.forEach((ele: any) => {
        const { contentRequestItemsId = null } = ele;
        if (contentRequestItemsId) {
          const { overallStatus = {} } = contentRequestItemsId;
          const isOverJobCompleted = overallStatus[authorType].isJobCompleted;
          if (isOverJobCompleted) {
            overAllStatusOfRole = overAllStatusOfRole + 1;
          }
        }
      })
      isJobDoneIsRequired = overAllStatusOfRole === filterArray.length
    } else {
      const { contentRequestItemsId = null } = testDetails;
      if (contentRequestItemsId) {
        const { overallStatus = {} } = contentRequestItemsId;
        const isOverJobCompleted = overallStatus[authorType].isJobCompleted;
        if (isOverJobCompleted) {
          overAllStatusOfRole = overAllStatusOfRole + 1;
        }
      }
      isJobDoneIsRequired = overAllStatusOfRole === 1;
    }
    return isJobDoneIsRequired;
  }

  buildMatchObject = (data: any, authorType: string) => {
    if(data) {
      const {
        match: { params },
      } = this.props;
      const requestId = params.requestId;

      let matchData = {
        params: {
          contentRequestId:requestId,
          role: authorType
        }
      }
      return matchData;
    }
  }

  toggleShowContentHistory = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showContentHistory: !prevState.showContentHistory
      }
    })
  }

  getRelevantSubjects = (): Subject[] => {
    const { ownerTaskByRoleData } = this.props;
    if(_.isEmpty(ownerTaskByRoleData)) {
      return [];
    }
    const subjects: Subject[] = _.get(ownerTaskByRoleData, 'requestInfo.details.subjects', []);
    return subjects.filter(({ questions }) => questions && !_.isEmpty(questions));
  }

  getTotalCount = (requestInfo: any, type: string) => {
    console.log({requestInfo, type})
    
    if(requestInfo) {

      if(type === 'test'){
        const { subjects } = requestInfo.details;
        let totalQuestions = 0;
        subjects.forEach((subject:any) => {
          const { questions } = subject;
          if(questions.length > 0) {
            questions.forEach((question:any) => {
              const { count } = question;
              if(count){
                totalQuestions += count;
              }
            })
          }
        })
        console.log('TEST - ', totalQuestions)
        return totalQuestions;
      }
  
      if(type === 'question') {
        const { totalCount } = requestInfo;
        console.log('Question - ', totalCount)
        return totalCount;
      }

    }
  }

  render() {
    const { classes, ownerTaskByRoleData } = this.props;
    console.log('Owner Task by Role Data', ownerTaskByRoleData);
    const { 
      totalCount, 
      statusCreated , 
      statusEvaluted, 
      statusLang,
      statusModerated,
      statusPublished, 
      progressCountCreator, 
      progressCountEvaluator, 
      progressCountLangEval, 
      progressCountModerator, 
      progressCountPublisher,
      hideProgressEval,
      hideProgressLang,
      hideProgressModerator,
      createdBy,
      evaluatedBy,
      langEvaluatedBy,
      moderatedBy,
      publishedBy
    } = this.state;
    const getGoalName =this.getGoalsForContent(ownerTaskByRoleData);
    const relevantSubjects = this.getRelevantSubjects();

    let questionsData = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.subjects', '');
    let contentType = !_.isEmpty(ownerTaskByRoleData) && this.getContentTypeForTable(ownerTaskByRoleData);
    let testData = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'details.testDetails', '');
    let testCount = !_.isEmpty(ownerTaskByRoleData) && _.get(ownerTaskByRoleData.requestInfo, 'totalCount', '');
    const priority = !_.isEmpty(ownerTaskByRoleData) ? _.get(ownerTaskByRoleData.requestInfo, 'priority', '') : '';
    let topNavValue = {
      "Priority": convertRequestPriorityToDislayValue(priority),
      "Deadline": !_.isEmpty(ownerTaskByRoleData) && dateService.dateOnly(this.getEndDateByRole(ownerTaskByRoleData)),
      "Goal": !_.isEmpty(ownerTaskByRoleData) && <MyPATTruncateText data={getGoalName}  truncateLength= {11} displayCount= {2}/>,
      "Subject": !_.isEmpty(ownerTaskByRoleData) && <MyPATTruncateText data={relevantSubjects.map((subject: any) => subject.name)}  truncateLength= {11} displayCount= {2}/>,
      "Assigned by": !_.isEmpty(ownerTaskByRoleData) && _.get(relevantSubjects, '[0].assignor.name', '')
    }

    let updatedQuestionsData = this.getAllQuestionsData(ownerTaskByRoleData);

    const percentageCreated = this.percentageConvert(totalCount, progressCountCreator);
    const percentageEvaluted = this.percentageConvert(totalCount, progressCountEvaluator);
    const percentageModerate = this.percentageConvert(totalCount, progressCountModerator);
    const percentageLangEval = this.percentageConvert(totalCount, progressCountLangEval);
    const percentagePublished =  this.percentageConvert(totalCount, progressCountPublisher);
    
    const {
      match: { params },
    } = this.props;
    const authorType = params.authorType;
    let isJobDoneDisabled = false
    isJobDoneDisabled = this.checkJobDoneDisabledForReview();
    const requestContentType=_.get(this.props.contentRequest,"requestInfo.type","");
    let type = requestContentType;

    let totalCountByType = this.getTotalCount(ownerTaskByRoleData && ownerTaskByRoleData.requestInfo, 
                                              type)
    console.log('Count by type', totalCountByType)
    let testDetails = testData;
    let filterArray = updatedQuestionsData;
    let dataQuesTest:any = [];
    let overalldataQuesTest = {};
    let totalCountQuestions = updatedQuestionsData.length;
    let totalCountTest = testDetails.totalCount;
    // let filterArray = ;
    // let isJobDoneIsRequired = this.getIsJobDoneIsRequired(type, filterArray, testDetails, authorType);
    let isJobDoneIsRequired = false;
    let match = this.buildMatchObject(ownerTaskByRoleData, authorType);

    const footerCTAName = this.getFooterCTA(authorType);
    return ownerTaskByRoleData  && Boolean(Object.keys(ownerTaskByRoleData).length) && (
          <>
          <DialogLarge
            headerTitle={`${ownerTaskByRoleData.requestId} | ${
              ownerTaskByRoleData.title
            }`}
            isFooter={true}
            topNavValue={topNavValue}
            isSaveHidden
            isShowHeader={true}
            isEditHidden
            isJobDoneDisabled={isJobDoneDisabled}
            footerCTAName={footerCTAName}
            onJobDone={this.onJobDone((ownerTaskByRoleData && ownerTaskByRoleData._id), authorType, (ownerTaskByRoleData && ownerTaskByRoleData.requestInfo && ownerTaskByRoleData.requestInfo.type))}
          >
            <Grid container className={classes.tabContainer} alignItems="center">
              <Grid item xs>
                <MyPATTabs defaultSelected="My Task">
                  <MyPATTab eventKey="My Task" isCustomCSS={true}>
                    <Grid
                      container
                      justify="flex-start"
                      className={classes.tabPanel}
                    >
                      <YourTaskListing totalCount ={testCount} questionData={questionsData} contentType={contentType} testData={testData} 
                      contentRequestId={ownerTaskByRoleData._id} authorType={authorType} testCount={testCount}
                      setActiveTabInParent={this.setActiveTab} updateData={this.updateData} authorDeadline={topNavValue["Deadline"]} testDetails={testDetails}/>
                    </Grid>
                  </MyPATTab>
                  <MyPATTab eventKey="Timeline" isCustomCSS={true}>
                    <Grid
                      container
                      justify="flex-start"
                      className={classes.tabPanel}
                      
                    >
                      {/* <Grid item xs={12}> */}
                        <TrackRequestProcess 
                            overallDone={isJobDoneIsRequired} 
                            type={type} 
                            testDetails={testDetails} 
                            questionData={filterArray} 
                            data={dataQuesTest} 
                            overallData={overalldataQuesTest} 
                            totalCount={totalCountByType} 
                            trackProgressData={filterArray} 
                            match={match} 
                            />
                      {/* </Grid> */}
                    </Grid>
                  </MyPATTab>

                
                  
                  <MyPATTab eventKey={'Order Notes'} isCustomCSS={true}>
                    <Grid className={classes.tabPanel}>
                  <OrderNotes
                    testName={
                              this.props.contentRequest &&
                              this.props.contentRequest.requestInfo &&
                              this.props.contentRequest.requestInfo.details &&
                              this.props.contentRequest.requestInfo.details.testDetails &&
                              this.props.contentRequest.requestInfo.details.testDetails.name}
                    subjects={this.props.contentRequest &&
                                this.getRelevantSubjects()
                              }
                    type={ this.props.contentRequest &&
                      this.props.contentRequest.requestInfo &&
                      this.props.contentRequest.requestInfo.details &&
                            this.props.contentRequest.requestInfo.details.testDetails &&
                          this.props.contentRequest.requestInfo.details.testDetails.type
                          }
                    orderNoteBy={
                      this.props.contentRequest &&
                      getRequestCreatorName(this.props.contentRequest)
                    }
                    attachments={_.get(this.props, 'contentRequest.requestInfo.orderNoteAttachments', [])}
                    note={
                      this.props.contentRequest &&
                      this.props.contentRequest.requestInfo &&
                      this.props.contentRequest.requestInfo.orderNote
                    }
                    requestContentType={requestContentType}
                    requestData={this.props.contentRequest}
                  />
                    </Grid>
                  </MyPATTab>
                </MyPATTabs>
              </Grid>
              <Grid item xs="auto" className={classNames(classes.clickable, classes.historyCTA)} onClick={this.toggleShowContentHistory}>
                <Grid container alignItems="center">
                  <Grid item xs="auto">
                    <img src="/assets/svg/contentRequest/history-clock.svg" alt="history" />
                  </Grid>
                  <Grid item xs="auto">
                    History
                  </Grid>
                </Grid >
              </Grid>
            </Grid>
          </DialogLarge>
          <RequestHistoryDrawer key={_.get(ownerTaskByRoleData, '_id', '')} contentRequest={ownerTaskByRoleData} open={this.state.showContentHistory} onClose={this.toggleShowContentHistory} />
        </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ownerTaskByRoleData:
    state.contentRequestReducer.contentRequestReducer.ownerTaskByRoleData,
   contentRequest: state.contentRequestReducer.contentRequestReducer.ownerTaskByRoleData,
   progressBarForQuestion: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
   progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForTest', {}),

});

// const mapDispatchToProps = {
//   getOwnerTaskByRoleData: getOwnerTaskByRoleData,
// };

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  getOwnerTaskByRoleData: getOwnerTaskByRoleData,
  setContentRequestState: contentRequestStateAction.setContentRequestStates,
  setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(ContentReceivedRequestLandingContainer));
